import React, { useState, useEffect } from 'react'
import { Button, Input, Select, formatSelectOptions } from '../../../../components'
import { useMessage } from '../../../../hooks'
import { eventFieldDefService } from '../../services'

const TYPE_OPTIONS = [
  { value: 'text', label: 'Text' },
  { value: 'number', label: 'Tal' },
  { value: 'boolean', label: 'Ja/Nej' },
]

const TYPE_LABELS = { text: 'Text', number: 'Tal', boolean: 'Ja/Nej' }

// Per-event custom-field manager — "table + inline add-row", same shape as
// clients' ClientContacts.js. onChange fires after every add/remove so the
// parent (EventDetail/GuestList) can refetch guests with the new field set.
export const FieldDefManager = ({ eventSlug, onChange }) => {
  const { showMessage } = useMessage()

  const [fieldDefs, setFieldDefs] = useState([])
  const [loading, setLoading] = useState(true)
  const [label, setLabel] = useState('')
  const [type, setType] = useState('text')
  const [adding, setAdding] = useState(false)

  const fetchFieldDefs = () => {
    setLoading(true)
    eventFieldDefService.getByEvent(eventSlug)
      .then(res => { setFieldDefs(res.fieldDefs || []); onChange && onChange(res.fieldDefs || []) })
      .catch(() => showMessage('Kunde inte ladda anpassade fält', 'error'))
      .finally(() => setLoading(false))
  }

  useEffect(() => { fetchFieldDefs() }, [eventSlug]) // eslint-disable-line react-hooks/exhaustive-deps

  const addFieldDef = () => {
    if (!label.trim()) return
    setAdding(true)
    eventFieldDefService.create({ event_slug: eventSlug, field_label: label.trim(), field_type: type })
      .then(() => { setLabel(''); setType('text'); fetchFieldDefs() })
      .catch(err => showMessage(err.message || 'Kunde inte lägga till fält', 'error'))
      .finally(() => setAdding(false))
  }

  const removeFieldDef = (fieldDef) => {
    eventFieldDefService.remove(fieldDef.event_field_def_id)
      .then(() => fetchFieldDefs())
      .catch(err => showMessage(err.message || 'Kunde inte ta bort fält', 'error'))
  }

  if (loading) return <p style={{ color: 'var(--color-dark-grey)' }}>Laddar…</p>

  return (
    <div>
      {fieldDefs.length === 0
        ? <p style={{ color: 'var(--color-dark-grey)', fontStyle: 'italic' }}>Inga anpassade fält ännu.</p>
        : (
          <table className="ev-table">
            <thead><tr><th>Fält</th><th>Typ</th><th></th></tr></thead>
            <tbody>
              {fieldDefs.map(fd => (
                <tr key={fd.event_field_def_id}>
                  <td>{fd.field_label}</td>
                  <td style={{ color: 'var(--color-dark-grey)' }}>{TYPE_LABELS[fd.field_type] || fd.field_type}</td>
                  <td><button className="button-icon" title="Ta bort" onClick={() => removeFieldDef(fd)}>✕</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )
      }

      <div className="ev-row ev-row-align-end" style={{ marginTop: 20 }}>
        <div className="form-block ev-form-block-wide">
          <label>Nytt fält</label>
          <Input type="text" placeholder="t.ex. Handicap" value={label} onChange={e => setLabel(e.target.value)} />
        </div>
        <div className="form-block">
          <label>Typ</label>
          <Select
            name="field_type"
            value={type}
            options={formatSelectOptions({ options: TYPE_OPTIONS, optionValue: 'value', optionLabel: 'label' })}
            onChange={({ value }) => setType(value || 'text')}
          />
        </div>
        <Button value={adding ? 'Lägger till…' : '+ Lägg till fält'} className="button" onClick={addFieldDef} disabled={!label.trim() || adding} />
      </div>
    </div>
  )
}
